import React from 'react';
import { Box, Container, Grid, Hidden } from '@mui/material';
import Summary from '../Components/Typography/Summary';
import Photo from '../Components/Photo';
import ArrowIcon from '../Components/ArrowIcon';
import Designation from '../Components/Typography/Designation';
import FullName from '../Components/Typography/FullName';
import ContentWrapper from '../Components/ContentWrapper';
import { PhotoAnimation } from '../Components/animation/PhotoAnimation';
import { DelayedWrapper } from '../Components/animation/DelayedWrapper';
import { EarlyWrapper } from '../Components/animation/EarlyWrapper';
import { LateWrapper } from '../Components/animation/LateWrapper';
import { ArrowAnimation } from '../Components/animation/ArrowAnimation';

const Home = () => {
  return (
    <ContentWrapper>
      <Container maxWidth='xxl'>
        {/* --- Intro (visibile only on sm) ---- */}
        <Hidden mdUp>
          <Grid container>
            <Grid item xs={8} sx={{ my: '20px' }}>
              <EarlyWrapper>
                <Summary />
              </EarlyWrapper>
            </Grid>
          </Grid>
        </Hidden>

        {/* ----- Designation ----- */}
        <Grid container>
          <Grid item xs={12}>
            <EarlyWrapper>
              <Designation />
            </EarlyWrapper>
          </Grid>
        </Grid>

        {/* ----- Photo -----  */}
        <Grid container>
          <Hidden mdUp>
            <Grid item xs={12}>
              <PhotoAnimation>
                <Photo />
              </PhotoAnimation>
            </Grid>
          </Hidden>
          <Hidden mdDown>
            <Grid item xs={2}></Grid>
            <Grid item xs={8}>
              <PhotoAnimation>
                <Photo />
              </PhotoAnimation>
            </Grid>
            <Grid item xs={2}></Grid>
          </Hidden>
        </Grid>

        {/* ----- Name ----- */}
        {/* ---- upto md screens ---- */}
        <Hidden mdUp>
          <Grid container>
            <Grid item xs={4}>
              <Box sx={{ mt: '43px' }}>
                <ArrowAnimation>
                  <ArrowIcon />
                </ArrowAnimation>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <DelayedWrapper>
                <FullName />
              </DelayedWrapper>
            </Grid>
          </Grid>
        </Hidden>

        {/* ----- above md screens ----  */}
        <Hidden mdDown>
          <Grid container>
            <Grid item xs={2}>
              <Box sx={{ mt: '43px' }}>
                <ArrowAnimation>
                  <ArrowIcon />
                </ArrowAnimation>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <LateWrapper>
                <Summary />
              </LateWrapper>
            </Grid>
            <Grid item xs={4}>
              <DelayedWrapper>
                <FullName />
              </DelayedWrapper>
            </Grid>
          </Grid>
        </Hidden>
      </Container>
    </ContentWrapper>
  );
};

export default Home;
